var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConstans(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#A7ABB0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92188 8.75C7.47656 8.98438 6.91797 9.10156 6.24609 9.10156C5.37891 9.10156 4.6862 8.82682 4.16797 8.27734C3.64974 7.72526 3.39062 6.99609 3.39062 6.08984C3.39062 5.11589 3.68229 4.33203 4.26562 3.73828C4.84896 3.14453 5.58984 2.84766 6.48828 2.84766C7.06641 2.84766 7.54427 2.92969 7.92188 3.09375V3.91016C7.48958 3.67057 7.01432 3.55078 6.49609 3.55078C5.82161 3.55078 5.27214 3.77604 4.84766 4.22656C4.42318 4.67448 4.21094 5.27995 4.21094 6.04297C4.21094 6.76693 4.40885 7.34245 4.80469 7.76953C5.20052 8.19401 5.71875 8.40625 6.35938 8.40625C6.95833 8.40625 7.47917 8.27083 7.92188 8V8.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstans);
export default __webpack_public_path__ + "static/media/constans.267f4ebf9a1f888556ef6650404ce039.svg";
export { ForwardRef as ReactComponent };